/* @ngInject */
const resource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.account}/:action`
  return $resource(
    path,
    { action: '@action' },
    {
      update: {
        method: 'PUT',
      },
      query: {
        method: 'GET',
      },
      get: {
        method: 'GET',
        isArray: false,
      },
      post: {
        method: 'POST',
      },
    }
  )
}

export default resource



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/resource.service.js